import React from 'react';
export function Conclusion() {
  return <section className="py-12 md:py-24 bg-brand-950 text-center" data-id="element-58">
      <div className="container mx-auto px-4" data-id="element-59">
        <div className="max-w-3xl mx-auto" data-id="element-60">
          <p className="text-lg md:text-4xl font-bold text-brand-200 leading-snug md:leading-relaxed mb-3 md:mb-6" data-id="element-61">
            No necesitás más contenido.
          </p>
          <p className="text-xl md:text-4xl font-extrabold text-white leading-snug md:leading-relaxed mb-4 md:mb-8" data-id="element-62">
            Necesitás un sistema claro para dar clases sin improvisar.
          </p>
          <div className="w-16 md:w-24 h-1 bg-accent-500 mx-auto rounded-full mb-4 md:mb-8" data-id="element-63"></div>
          <p className="text-base md:text-xl text-brand-400 font-medium" data-id="element-64">
            Eso es exactamente lo que vas a tener acá.
          </p>
        </div>
      </div>
    </section>;
}